import { Skeleton } from "@mantine/core";

import CardWrapper     from "_components/atoms/cardWrapper";
import useStylesLoader from "_styles/organisms/imageLoader";
import useStyles       from "_styles/organisms/searchResultsSkeleton";

export const SearchStreamerSkeleton = ( ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.divider }>
			{/* <CardWrapper className = { classes.cardWrapper }> */}
			<div className = { classes.skeletonContainer }>
				<Skeleton
					circle
					height = { "13rem" }
					radius = "xl"
				/>

				<div>
					<Skeleton animation = "wave"
						radius             = { "lg" }
						style              = { { marginLeft: "10rem", marginBottom: "1rem", height: "2.5rem", width: "20rem" } }
						variant            = "rectangular"
					/>

					<Skeleton animation = "wave"
						radius             = { "lg" }
						style              = { { marginLeft: "10rem", marginBottom: "1rem", height: "2.5rem", width: "20rem" } }
						variant            = "rectangular"
					/>

					<Skeleton animation = "wave"
						radius             = { "lg" }
						style              = { { marginLeft: "10rem", marginBottom: "1rem", height: "2.5rem", width: "60rem" } }
						variant            = "rectangular"
					/>
				</div>
			</div>

			{/* </CardWrapper> */}
		</div>
	);
};

export const LiveStreamSkeleton = ( { activeTab, index } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.liveStreamDivider }>
			<CardWrapper>
				<div className = { classes.liveStreamContainer }>

					<div className = { classes.liveStreamCard }>

						<Skeleton animation = "wave"
							radius             = { "lg" }
							style              = { { height: "15rem", width: "26.5rem", borderRadius: "10px" } }
							variant            = "rectangular"
						/>

						<div className = { classes.liveStreamSide }>
							<Skeleton animation = "wave"
								radius             = { "lg" }
								style              = { { marginBottom: "1.4rem", height: "2.5rem", width: "60rem" } }
								variant            = "rectangular"
							/>

							<Skeleton animation = "wave"
								radius             = { "lg" }
								style              = { { marginBottom: "1.4rem", height: "2.5rem", width: "30rem" } }
								variant            = "rectangular"
							/>

							<Skeleton animation = "wave"
								radius             = { "lg" }
								style              = { { marginBottom: "1rem", height: "2.5rem", width: "15rem" } }
								variant            = "rectangular"
							/>
						</div>

					</div>
				</div>
			</CardWrapper>
		</div>
	);
};

export const ImageLoadingSkeleton = ( { bottomLeftFlag, bottomRightFlag, topLeftFlag, topRightFlag } ) => {

	const { classes } = useStylesLoader ( { bottomLeftFlag, bottomRightFlag, topLeftFlag, topRightFlag } );

	return (

		<Skeleton
			animation = "wave"
			className = { classes.imageLoaderStyles }
			radius    = { "lg" }
			variant   = "reactangle"
		/>

	);
};
